export const EntityContext = 'entity';
